import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';
import {FilterIcon, SquareMinusIcon} from "assets/images";

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 296px;
  height: 444px;
  overflow: hidden;
`;

export const TickersSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 372px;
`;

export const TopElementsDiv = styled.div`
  background-color: ${({ theme }) => theme.bg.grey};
  padding: 15px 15px 18px;
`;

export const TickersTitle = styled.h4`
  margin: 0 0 15px;
  font-weight: 600;
`;

export const SelectDiv = styled(Scrollbars)`
  height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`;

export const TickerName = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CustomSquareMinusIcon = styled(SquareMinusIcon)`
  cursor: pointer;
`;

export const CustomFilterIcon = styled(FilterIcon)`
  cursor: pointer;
`

export const TickerItemDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  padding: 0 20px;
  border-bottom: 1px solid rgba(98, 147, 97, 0.15);

  :hover {
    cursor: pointer;
  }
`;








